import api from "./apiConfig";
import { loginFirebaseUser, logoutFirebaseUser } from "./firebaseService";

//=================================
//===========  Auth  ==============
//=================================
export const createUser = async (payload) => {
  try {
    const response = await api.post("/signup", payload);
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error: error };
  }
};

export const verifyUser = async (payload) => {
  try {
    const response = await api.post("/verify", payload);
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const loginUser = async (payload) => {
  try {
    const response = await api.post("/login", payload);
    localStorage.setItem("token", response.data.snappilyToken.token);
    loginFirebaseUser(response.data.firebaseToken);
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiVerifyCurrentEmail = async (payload) => {
  try {
    const response = await api.post("/verify-current-email", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiConfirmEmail = async (payload) => {
  try {
    const response = await api.post("/confirm-email", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiChangeEmail = async (payload) => {
  try {
    const response = await api.post("/change-email", payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const getAuthenticatedUser = async () => {
  try {
    const response = await api.get("/me", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    // console.error(error);
    console.log("No user authenticated");
    return { hasError: true, error };
  }
};

export const logout = async () => {
  console.log("logout function is running");
  try {
    await api.delete("/logout", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    logoutFirebaseUser();
    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};

//=================================
//===========  Users  =============
//=================================

export const getAllUsers = async () => {
  return await api.get(`/users`);
};

export const getUserById = async (id) => {
  return await api.get(`/users/${id}`);
};

export const apiUploadUserId = async (id, url) => {
  try {
    const response = await api.put(`/users/identification/${id}`, url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiUpdateUser = async (id, user) => {
  try {
    const response = await api.put(`/users/${id}`, user, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const deleteUser = async (id, user) => {
  return await api.put(`/users/${id}`, user);
};

//=================================
//========  Properties  ===========
//=================================
export const apiGetAllProperties = async () => {
  return await api.get(`/properties`);
};

export const apiCreateProperty = async (property) => {
  try {
    const response = await api.post(`/properties`, property, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetPropertyById = async (id) => {
  return await api.get(`/properties/${id}`);
};

export const apiUpdateProperty = async (id, property) => {
  try {
    const response = await api.put(`/properties/${id}`, property, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiDeleteProperty = async (id) => {
  try {
    const response = await api.delete(`/properties/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

//=================================
//===========  Rooms  =============
//=================================
export const getAllRooms = async () => {
  return await api.get(`/rooms`);
};

export const apiCreateRoom = async (room) => {
  try {
    const response = await api.post(`/rooms`, room, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const getRoomById = async (id) => {
  return await api.get(`/rooms/${id}`);
};

export const apiUpdateRoom = async (id, room) => {
  try {
    const response = await api.put(`/rooms/${id}`, room, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiDeleteRoom = async (id, room) => {
  try {
    const response = await api.delete(`/rooms/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

//=================================
//==========  Leases  =============
//=================================
export const apiGetAllLeases = async () => {
  return await api.get(`/leases`);
};

export const apiCreateLease = async (lease) => {
  try {
    const response = await api.post(`/leases`, lease, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(Error);
    return { hasError: true, error };
  }
};

export const apiGetLeaseById = async (id) => {
  return await api.get(`/leases/${id}`);
};

export const apiUpdateLease = async (id, lease) => {
  try {
    const response = await api.put(`/leases/${id}`, lease, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiAddTenantSignature = async (id, lease) => {
  try {
    const response = await api.put(`/leases/tenant-signature/${id}`, lease, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiAddLandlordSignature = async (id, lease) => {
  try {
    const response = await api.put(`/leases/landlord-signature/${id}`, lease, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiDeleteLease = async (id) => {
  try {
    const response = await api.delete(`/leases/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

//=================================
//======  Archived Leases  ========
//=================================
export const apiGetAllLeaseArchives = async () => {
  return await api.get(`/lease-archives`);
};

export const apiCreateLeaseArchive = async (archivedLease) => {
  try {
    const response = await api.post(`/lease-archives`, archivedLease, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetLeaseArchiveById = async (id) => {
  return await api.get(`/lease-archives/${id}`);
};

export const apiUpdateLeaseArchive = async (id, archivedLease) => {
  try {
    const response = await api.put(`/lease-archives/${id}`, archivedLease, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

// export const deleteLeaseArchive = async (id) => {
//   return await api.delete(`/lease-archives/${id}`);
// };

//=================================
//=======  Conversations  =========
//=================================
export const apiGetAllConversations = async () => {
  return await api.get(`/conversations`);
};

export const apiCreateConversation = async (conversation) => {
  try {
    const response = await api.post(`/conversations`, conversation, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetConversationById = async (id) => {
  return await api.get(`/conversations/${id}`);
};

export const apiUpdateConversation = async (id, conversation) => {
  try {
    const response = await api.put(`/conversations/${id}`, conversation, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiDeleteConversation = async (id) => {
  return await api.put(`/conversations/${id}`);
};

//=================================
//=========  Messages  ============
//=================================
export const apiGetMessagesByConversationId = async (id) => {
  return await api.get(`/messages/conversation/${id}`);
};

export const apiCreateMessage = async (message) => {
  try {
    const response = await api.post(`/messages`, message, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetMessageById = async (id) => {
  return await api.get(`/messages/${id}`);
};

export const apiUpdateMessage = async (id, message) => {
  try {
    const response = await api.post(`/messages/${id}`, message, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiDeleteMessage = async (id) => {
  return await api.put(`/messages/${id}`);
};

//=================================
//========  Transactions  =========
//=================================
export const apiGetTransactionsByRoomId = async (id) => {
  return await api.get(`/transactions/rooms/${id}`); // by leaseId
};

export const apiCreateTransaction = async (transaction) => {
  try {
    const response = await api.post(`/transactions`, transaction, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetTransactionById = async (id) => {
  return await api.get(`/transactions/${id}`);
};

export const apiUpdateTransaction = async (id, transaction) => {
  try {
    const response = await api.put(`/transactions/${id}`, transaction, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiDeleteTransaction = async (id) => {
  try {
    const response = await api.put(`/transactions/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

//=================================
//=======  Published Rooms  =======
//=================================
export const apiGetAllPublishedRooms = async (payload) => {
  try {
    const response = await api.post(`/search-published-rooms/`, payload);
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiCreatePublishedRoom = async (publishedRoom) => {
  try {
    const response = await api.post(`/published-rooms`, publishedRoom, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetPublishedRoomById = async (uuid) => {
  try {
    const response = await api.get(`/published-rooms/${uuid}`);
    return { data: response.data, hasError: false };
  } catch (error) {
    return { hasError: true, error };
  }
};

export const apiUpdatePublishedRoom = async (uuid, publishedRoom) => {
  try {
    const response = await api.put(`/published-rooms/${uuid}`, publishedRoom, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiDeletePublishedRoom = async (uuid) => {
  try {
    const response = await api.delete(`/published-rooms/${uuid}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

//=================================
//===========  Bills  =============
//=================================
export const apiGetBillsByPropertyId = async (id) => {
  return await api.get(`/bills/property/${id}`);
};

export const apiCreateBill = async (bill) => {
  try {
    const response = await api.post(`/bills`, bill, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetBillById = async (id) => {
  return await api.get(`/bills/${id}`);
};

export const apiUpdateBill = async (id, bill) => {
  try {
    const response = await api.put(`/bills/${id}`, bill, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiDeleteBill = async (id) => {
  try {
    const response = await api.delete(`/bills/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

//=================================
//===========  Chores  ============
//=================================
export const apiGetChoresByPropertyId = async (id) => {
  return await api.get(`/chores/property/${id}`);
};

export const apiCreateChore = async (chore) => {
  try {
    const response = await api.post(`/chores`, chore, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetChoreById = async (id) => {
  return await api.get(`/chores/${id}`);
};

export const apiUpdateChore = async (id, chore) => {
  try {
    const response = await api.put(`/chores/${id}`, chore, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiDeleteChore = async (id) => {
  try {
    const response = await api.delete(`/chores/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

//=================================
//=========  Expenses  ============
//=================================
export const getExpensesByPropertyId = async (id) => {
  return await api.get(`/expenses/property/${id}`);
};

export const apiCreateExpense = async (expense) => {
  try {
    const response = await api.post(`/expenses`, expense, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const getExpenseById = async (id) => {
  return await api.get(`/expenses/${id}`);
};

export const updateExpense = async (id, expense) => {
  return await api.put(`/expenses/${id}`, expense);
};

export const deleteExpense = async (id) => {
  return await api.delete(`/expenses/${id}`);
};

//=================================
//===========  Stripe  ============
//=================================
export const apiCreateStripeAccount = async (address) => {
  try {
    const response = await api.post(`/stripe/account`, address, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiCreateStripeSession = async (account) => {
  try {
    const response = await api.post(`/stripe/session`, account, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiAchCheckout = async (payment) => {
  try {
    const response = await api.post(`/stripe/ach-checkout`, payment, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiCardCheckout = async (payment) => {
  try {
    const response = await api.post(`/stripe/card-checkout`, payment, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiPaymentStatus = async (sessionId) => {
  try {
    const response = await api.get(`/stripe/payment-status/${sessionId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiCreateSubscription = async (subscriptionType) => {
  try {
    const response = await api.get(
      `/stripe/create-subscription/${subscriptionType}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      },
    );
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiSubscriptionStatus = async (sessionId) => {
  try {
    const response = await api.get(`/stripe/subscription-status/${sessionId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiCreateBillingPortal = async () => {
  try {
    const response = await api.post(`/stripe/billing-portal-session`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

//=================================
//=========  New Inquiry  =========
//=================================
export const apiNewInquiry = async (inquiry) => {
  try {
    const response = await api.post(`/new-inquiry/`, inquiry);
    return { data: response.data, hasError: false, status: response.status };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

//=================================
//========  Notifications  ========
//=================================
export const getNotifications = async () => {
  try {
    const response = await api.get("/notifications", {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

export const apiUpdateNotifications = async (notifications) => {
  try {
    const response = await api.put(`/notifications`, notifications, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false, status: response.status };
  } catch (error) {
    console.error(error);
    return { hasError: true, error };
  }
};

//=================================
//========  Email Relay  ==========
//=================================
export const apiCreateEmailRelay = async (roomId) => {
  try {
    const response = await api.get(`email-relay/generate/${roomId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false, status: response.status };
  } catch (error) {
    // console.error(error);
    return { hasError: true, error };
  }
};

export const apiReportAbuse = async (relayId, payload) => {
  try {
    const response = await api.put(`email-relay/abuse/${relayId}`, payload, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false, status: response.status };
  } catch (error) {
    // console.error(error);
    return { hasError: true, error };
  }
};

//=================================
//====== Browser Fingerprints =====
//=================================
export const apiGetUserIp = async (id, payload) => {
  try {
    const response = await api.get(`fingerprints/ip/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "X-GPU-ID": payload.canvasId,
        "X-AUDIO-ID": payload.audioId,
      },
    });
    return { data: response.data, hasError: false, status: response.status };
  } catch (error) {
    // console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetCookies = async (id) => {
  try {
    const response = await api.get(`fingerprints/cookies/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false, status: response.status };
  } catch (error) {
    // console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetUserAgent = async (id) => {
  try {
    const response = await api.get(`fingerprints/user-agent/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false, status: response.status };
  } catch (error) {
    // console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetUniqueId = async (id) => {
  try {
    const response = await api.get(`fingerprints/uuid/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    });
    return { data: response.data, hasError: false, status: response.status };
  } catch (error) {
    // console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetGpuId = async (id, payload) => {
  try {
    const response = await api.get(`fingerprints/gpu-id/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "X-GPU-ID": payload.canvasId,
        "X-GPU-MODEL": payload.gpuModel,
      },
    });
    return { data: response.data, hasError: false, status: response.status };
  } catch (error) {
    // console.error(error);
    return { hasError: true, error };
  }
};

export const apiGetAudioId = async (id, payload) => {
  try {
    const response = await api.get(`fingerprints/audio-id/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "X-AUDIO-ID": payload,
      },
    });
    return { data: response.data, hasError: false, status: response.status };
  } catch (error) {
    // console.error(error);
    return { hasError: true, error };
  }
};
